import timezonesJSON from 'timezones.json';
import { uniq } from 'lodash';

export const timezones: string[] = uniq(
  timezonesJSON.flatMap((timezone) => timezone.utc).sort()
);
